import { LogObject, accessibilityAddAttributeClickParams, accessibilityAttributeChangedParams, accessibilityAttributeThreeDotsClickParams, actionSuccessParams, addAppDependencyClickParams, addElementsAddDashboardElementsParams, addElementsViewWixDesignSystemParams, addPresetParams, addWidgetIntoWidgetClickParams, addWidgetIntoWidgetSuccessParams, appApiReferenceClickParams, appDashboardCopyToClipboardParams, appDependencyChoseParams, appHistoryAppStructurePanelClickParams, appHistoryLoadMoreClickParams, appHistoryLoadedParams, appHistoryRestoreVersionFailedParams, appHistoryRestoreVersionIntentParams, appHistoryRestoreVersionSuccessParams, appHistoryVersionFilterClickParams, appHistoryVersionSelectedParams, appLinkActionsParams, appNameAndDescriptionAddedParams, appNameInTheTopBarClickParams, appNamespaceCreatedParams, appNamespaceTryParams, archiveAppParams, blocksAppCreatedParams, blocksAppCreatedServerParams, blocksBuilderBuildClickParams, blocksBuilderBuildSuccessParams, blocksBuilderClickOnBuildParams, blocksBuilderEditAppClickParams, blocksBuilderGetAppLinkClickParams, blocksBuilderTestClickParams, blocksBuilderTestVersionCreatedParams, blocksCreatePackageApiCallParams, blocksPanelCtaClickParams, blocksPanelPanelClosedParams, blocksPanelPanelLoadedParams, blocksReorderItemInListParams, blocksWidgetAddWidgetParams, blocksWidgetThreeDotsMenuActionClickParams, blocksWidgetThreeDotsMenuClickParams, blocksWidgetWidgetDeletedParams, blocksWidgetWidgetDuplicatedParams, blocksWidgetWidgetRenamedParams, buildFailedCodeSyntaxErrorParams, clickOnSaveLocalEditorParams, configActionButtonAddedParams, configAddActionButtonClickParams, configGfppButtonActionsOptionClickedParams, configGfppNewActionSetParams, configManifestBehaviorChangedParams, configManifestDisplayNameChangedParams, consumptionAddWidgetToPageParams, dashboardPageDeletedParams, dashboardPagesCreateAppDashboardParams, deprecatedComplexSelectorParams, designCustomColorParams, designLinkedToSiteThemeClickParams, designTestThemeClickParams, designThemeOnPreviewChosenParams, dropDownMenuClickParams, editorExperienceSwitchTabsParams, editorExperienceWelcomePanelClickParams, gettingStartedClickParams, helpClickParams, layoutCustomizationAddDesignVariableClickParams, layoutCustomizationDesignVariableContextMenuClickParams, layoutCustomizationDesignVariableDeletedParams, layoutCustomizationDesignVariableNextClickParams, layoutCustomizationDesignVariableRenamedParams, layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams, layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams, layoutCustomizationEditDesignVariablePresetValuesEditedParams, layoutCustomizationLinkToMorePropertiesParams, layoutCustomizationLinkVariableToComponentParams, layoutCustomizationLinkVariableToComponentPropertyDoneParams, leftBarClickParams, mainActionSettingsConfigurationParams, modalShownParams, multilingualAddLanguageContinueClickParams, multilingualAddLanguagesClickParams, multilingualLanguageAddedSuccessfullyParams, multilingualOpenMultilingualControlParams, multilingualSwitchLanguageParams, namespaceFailedPanelTryAgainClickParams, openExistingAppParams, panelBuilderAddElementBrowseAllClickParams, panelBuilderAddElementClickParams, panelBuilderChooseElementToAddParams, panelBuilderCreateNewPanelClickParams, panelBuilderDeleteElementParams, panelBuilderNewPanelCreatedParams, panelBuilderPanelPropertiesChangedParams, panelBuilderReorderElementParams, popUpClickedParams, popUpOpenedParams, presetDeletedParams, presetDuplicatedParams, presetRenamedParams, previewPresetSelectParams, privateAppsAutomaticMinorUpdatesToggleParams, privateAppsAutomaticMinorUpdatesTurnedOnParams, privateAppsAvailableAppsContextMenuClickParams, privateAppsCreateNewAppClickParams, privateAppsInstallAppClickParams, privateAppsInstallAppSuccessParams, privateAppsInstalledAppsContextMenuClickParams, privateAppsLeftTreeContextMenuClickParams, privateAppsPrivateAppsLeftBarClickParams, privateAppsUninstallAppClickParams, privateAppsUninstallAppSuccessParams, privateAppsUpdateAppVersionParams, propertiesChangedParams, removeAppDependencyParams, savePackageSuccessParams, shareableUrlButtonClickParams, shareableUrlCreationResultParams, shareableUrlOpenedParams, switchWorkspaceParams, testApiPropertiesClickParams, toggleClickParams, topBarTabsClickParams, topBarTitleActionParams, updateAppSuccessParams, welcomeScreenArticleClickParams, welcomeScreenItemClickParams, welcomeScreenSeeAllAppsClickParams, widgetApiManageAddEventClickParams, widgetApiManageAddEventParams, widgetApiManageAddFunctionClickParams, widgetApiManageAddPropertyClickParams, widgetApiManageAddPropertyParams, widgetApiManageAddPropertyToCustomTypeClickParams, widgetApiManageAddPropertyToCustomTypeParams, widgetApiManageCustomTypeActionClickParams, widgetApiManageDeleteEventParams, widgetApiManageDeletePropertyParams, widgetApiManageEditCustomTypeClickParams, widgetApiManageEditEventClickParams, widgetApiManageEditPropertyClickParams, widgetApiManageUpdateEventParams, widgetApiManageUpdatePropertyParams, widgetApiVisibilityChangedParams, widgetFromWidgetLibrariesAddedParams } from '../types';

/**
 * A function to create a log object for the 'accessibilityAddAttributeClick' event (evid: 3073)
 *
 * Event description: same to 38:1229
 *
 * @param {accessibilityAddAttributeClickParams} params - The parameters for this event
 * @return {LogObject<accessibilityAddAttributeClickParams>} LogObject<accessibilityAddAttributeClickParams>
 */
export function accessibilityAddAttributeClick(params: accessibilityAddAttributeClickParams): LogObject<accessibilityAddAttributeClickParams> {
  throw new Error('accessibilityAddAttributeClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configActionButtonAdded' event (evid: 3044)
 *
 * Event description: Config - Action Button Added
 *
 * @param {configActionButtonAddedParams} params - The parameters for this event
 * @return {LogObject<configActionButtonAddedParams>} LogObject<configActionButtonAddedParams>
 */
export function configActionButtonAdded(params: configActionButtonAddedParams): LogObject<configActionButtonAddedParams> {
  throw new Error('configActionButtonAdded cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationEditDesignVariableLinkedPropertyDeleted' event (evid: 3085)
 *
 * Event description: Layout customization: fires once a user deletes a linked property inside the edit mode
 *
 * @param {layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams>} LogObject<layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams>
 */
export function layoutCustomizationEditDesignVariableLinkedPropertyDeleted(params: layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams): LogObject<layoutCustomizationEditDesignVariableLinkedPropertyDeletedParams> {
  throw new Error('layoutCustomizationEditDesignVariableLinkedPropertyDeleted cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addElementsAddDashboardElements' event (evid: 3132)
 *
 * Event description: BI event indicating click on "Add Dashboard Elements" on Add Elements section on Dashboard tab
 *
 * @param {addElementsAddDashboardElementsParams} params - The parameters for this event
 * @return {LogObject<addElementsAddDashboardElementsParams>} LogObject<addElementsAddDashboardElementsParams>
 */
export function addElementsAddDashboardElements(params: addElementsAddDashboardElementsParams): LogObject<addElementsAddDashboardElementsParams> {
  throw new Error('addElementsAddDashboardElements cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationDesignVariableContextMenuClick' event (evid: 3081)
 *
 * Event description: Layout customization: fires when a user clicks on the variable three dots
 *
 * @param {layoutCustomizationDesignVariableContextMenuClickParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationDesignVariableContextMenuClickParams>} LogObject<layoutCustomizationDesignVariableContextMenuClickParams>
 */
export function layoutCustomizationDesignVariableContextMenuClick(params: layoutCustomizationDesignVariableContextMenuClickParams): LogObject<layoutCustomizationDesignVariableContextMenuClickParams> {
  throw new Error('layoutCustomizationDesignVariableContextMenuClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configGfppButtonActionsOptionClicked' event (evid: 3042)
 *
 * Event description: User click
 *  button settings / define action / remove
 * in Config tab
 *
 * @param {configGfppButtonActionsOptionClickedParams} params - The parameters for this event
 * @return {LogObject<configGfppButtonActionsOptionClickedParams>} LogObject<configGfppButtonActionsOptionClickedParams>
 */
export function configGfppButtonActionsOptionClicked(params: configGfppButtonActionsOptionClickedParams): LogObject<configGfppButtonActionsOptionClickedParams> {
  throw new Error('configGfppButtonActionsOptionClicked cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'buildFailedCodeSyntaxError' event (evid: 3137)
 *
 * Event description: The event fired when the build process failed due to a code syntax error
 *
 * @param {buildFailedCodeSyntaxErrorParams} params - The parameters for this event
 * @return {LogObject<buildFailedCodeSyntaxErrorParams>} LogObject<buildFailedCodeSyntaxErrorParams>
 */
export function buildFailedCodeSyntaxError(params: buildFailedCodeSyntaxErrorParams): LogObject<buildFailedCodeSyntaxErrorParams> {
  throw new Error('buildFailedCodeSyntaxError cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appNameAndDescriptionAdded' event (evid: 3094)
 *
 * Event description: event is fired when a user adds an app name and app description (modal triggers during the build process or during creating collections process)
 *
 * @param {appNameAndDescriptionAddedParams} params - The parameters for this event
 * @return {LogObject<appNameAndDescriptionAddedParams>} LogObject<appNameAndDescriptionAddedParams>
 */
export function appNameAndDescriptionAdded(params: appNameAndDescriptionAddedParams): LogObject<appNameAndDescriptionAddedParams> {
  throw new Error('appNameAndDescriptionAdded cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderTestVersionCreated' event (evid: 3067)
 *
 * Event description: Blocks builder - test version created
 *
 * @param {blocksBuilderTestVersionCreatedParams} params - The parameters for this event
 * @return {LogObject<blocksBuilderTestVersionCreatedParams>} LogObject<blocksBuilderTestVersionCreatedParams>
 */
export function blocksBuilderTestVersionCreated(params: blocksBuilderTestVersionCreatedParams): LogObject<blocksBuilderTestVersionCreatedParams> {
  throw new Error('blocksBuilderTestVersionCreated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderCreateNewPanelClick' event (evid: 3055)
 *
 * Event description: Panel Builder - Create New Panel Click
 *
 * @param {panelBuilderCreateNewPanelClickParams} params - The parameters for this event
 * @return {LogObject<panelBuilderCreateNewPanelClickParams>} LogObject<panelBuilderCreateNewPanelClickParams>
 */
export function panelBuilderCreateNewPanelClick(params: panelBuilderCreateNewPanelClickParams): LogObject<panelBuilderCreateNewPanelClickParams> {
  throw new Error('panelBuilderCreateNewPanelClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderNewPanelCreated' event (evid: 3071)
 *
 * @param {panelBuilderNewPanelCreatedParams} params - The parameters for this event
 * @return {LogObject<panelBuilderNewPanelCreatedParams>} LogObject<panelBuilderNewPanelCreatedParams>
 */
export function panelBuilderNewPanelCreated(params: panelBuilderNewPanelCreatedParams): LogObject<panelBuilderNewPanelCreatedParams> {
  throw new Error('panelBuilderNewPanelCreated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderBuildClick' event (evid: 3003)
 *
 * Event description: user clicked on 'build' button
 *
 * @param {blocksBuilderBuildClickParams} params - The parameters for this event
 * @return {LogObject<blocksBuilderBuildClickParams>} LogObject<blocksBuilderBuildClickParams>
 */
export function blocksBuilderBuildClick(params: blocksBuilderBuildClickParams): LogObject<blocksBuilderBuildClickParams> {
  throw new Error('blocksBuilderBuildClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationLinkVariableToComponentPropertyDone' event (evid: 3080)
 *
 * Event description: Layout customization: fires when a user clicks the Done button and finishes defining the design variable
 *
 * @param {layoutCustomizationLinkVariableToComponentPropertyDoneParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationLinkVariableToComponentPropertyDoneParams>} LogObject<layoutCustomizationLinkVariableToComponentPropertyDoneParams>
 */
export function layoutCustomizationLinkVariableToComponentPropertyDone(params: layoutCustomizationLinkVariableToComponentPropertyDoneParams): LogObject<layoutCustomizationLinkVariableToComponentPropertyDoneParams> {
  throw new Error('layoutCustomizationLinkVariableToComponentPropertyDone cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'multilingualAddLanguageContinueClick' event (evid: 3107)
 *
 * Event description: event is fired when a user clicks on continue after choosing languages
 *
 * @param {multilingualAddLanguageContinueClickParams} params - The parameters for this event
 * @return {LogObject<multilingualAddLanguageContinueClickParams>} LogObject<multilingualAddLanguageContinueClickParams>
 */
export function multilingualAddLanguageContinueClick(params: multilingualAddLanguageContinueClickParams): LogObject<multilingualAddLanguageContinueClickParams> {
  throw new Error('multilingualAddLanguageContinueClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'accessibilityAttributeThreeDotsClick' event (evid: 3075)
 *
 * Event description: similar to 38:1230
 *
 * @param {accessibilityAttributeThreeDotsClickParams} params - The parameters for this event
 * @return {LogObject<accessibilityAttributeThreeDotsClickParams>} LogObject<accessibilityAttributeThreeDotsClickParams>
 */
export function accessibilityAttributeThreeDotsClick(params: accessibilityAttributeThreeDotsClickParams): LogObject<accessibilityAttributeThreeDotsClickParams> {
  throw new Error('accessibilityAttributeThreeDotsClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageDeleteEvent' event (evid: 3026)
 *
 * Event description: user click delete to delete an event
 *
 * @param {widgetApiManageDeleteEventParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageDeleteEventParams>} LogObject<widgetApiManageDeleteEventParams>
 */
export function widgetApiManageDeleteEvent(params: widgetApiManageDeleteEventParams): LogObject<widgetApiManageDeleteEventParams> {
  throw new Error('widgetApiManageDeleteEvent cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'helpClick' event (evid: 3014)
 *
 * Event description: Help Click
 *
 * @param {helpClickParams} params - The parameters for this event
 * @return {LogObject<helpClickParams>} LogObject<helpClickParams>
 */
export function helpClick(params: helpClickParams): LogObject<helpClickParams> {
  throw new Error('helpClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddPropertyClick' event (evid: 3017)
 *
 * Event description: user click to add property
 *
 * @param {widgetApiManageAddPropertyClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddPropertyClickParams>} LogObject<widgetApiManageAddPropertyClickParams>
 */
export function widgetApiManageAddPropertyClick(params: widgetApiManageAddPropertyClickParams): LogObject<widgetApiManageAddPropertyClickParams> {
  throw new Error('widgetApiManageAddPropertyClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'dashboardPageDeleted' event (evid: 3114)
 *
 * Event description: Event is fired when the deletion of the dashboard succeeds
 *
 * @param {dashboardPageDeletedParams} params - The parameters for this event
 * @return {LogObject<dashboardPageDeletedParams>} LogObject<dashboardPageDeletedParams>
 */
export function dashboardPageDeleted(params: dashboardPageDeletedParams): LogObject<dashboardPageDeletedParams> {
  throw new Error('dashboardPageDeleted cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configGfppNewActionSet' event (evid: 3045)
 *
 * Event description: BI for Choosing new Action for Main Action/Button Settings
 *
 * @param {configGfppNewActionSetParams} params - The parameters for this event
 * @return {LogObject<configGfppNewActionSetParams>} LogObject<configGfppNewActionSetParams>
 */
export function configGfppNewActionSet(params: configGfppNewActionSetParams): LogObject<configGfppNewActionSetParams> {
  throw new Error('configGfppNewActionSet cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appNamespaceCreated' event (evid: 3091)
 *
 * Event description: event is fired when a user creates a namespace for his app (needed when the app has code files or collections)
 *
 * @param {appNamespaceCreatedParams} params - The parameters for this event
 * @return {LogObject<appNamespaceCreatedParams>} LogObject<appNamespaceCreatedParams>
 */
export function appNamespaceCreated(params: appNamespaceCreatedParams): LogObject<appNamespaceCreatedParams> {
  throw new Error('appNamespaceCreated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryVersionFilterClick' event (evid: 3121)
 *
 * Event description: Fired when version filter is being used in Version Sidebar
 *
 * @param {appHistoryVersionFilterClickParams} params - The parameters for this event
 * @return {LogObject<appHistoryVersionFilterClickParams>} LogObject<appHistoryVersionFilterClickParams>
 */
export function appHistoryVersionFilterClick(params: appHistoryVersionFilterClickParams): LogObject<appHistoryVersionFilterClickParams> {
  throw new Error('appHistoryVersionFilterClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderTestClick' event (evid: 3066)
 *
 * Event description: Blocks builder - test click
 *
 * @param {blocksBuilderTestClickParams} params - The parameters for this event
 * @return {LogObject<blocksBuilderTestClickParams>} LogObject<blocksBuilderTestClickParams>
 */
export function blocksBuilderTestClick(params: blocksBuilderTestClickParams): LogObject<blocksBuilderTestClickParams> {
  throw new Error('blocksBuilderTestClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addWidgetIntoWidgetClick' event (evid: 3034)
 *
 * Event description: Add Widget into Widget: click
 *
 * @param {addWidgetIntoWidgetClickParams} params - The parameters for this event
 * @return {LogObject<addWidgetIntoWidgetClickParams>} LogObject<addWidgetIntoWidgetClickParams>
 */
export function addWidgetIntoWidgetClick(params: addWidgetIntoWidgetClickParams): LogObject<addWidgetIntoWidgetClickParams> {
  throw new Error('addWidgetIntoWidgetClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetWidgetDuplicated' event (evid: 3011)
 *
 * Event description: widget is Duplicated successfully
 *
 * @param {blocksWidgetWidgetDuplicatedParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetWidgetDuplicatedParams>} LogObject<blocksWidgetWidgetDuplicatedParams>
 */
export function blocksWidgetWidgetDuplicated(params: blocksWidgetWidgetDuplicatedParams): LogObject<blocksWidgetWidgetDuplicatedParams> {
  throw new Error('blocksWidgetWidgetDuplicated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderEditAppClick' event (evid: 3006)
 *
 * Event description: user clicked on 'edit app' button in preview mode
 *
 * @param {blocksBuilderEditAppClickParams} params - The parameters for this event
 * @return {LogObject<blocksBuilderEditAppClickParams>} LogObject<blocksBuilderEditAppClickParams>
 */
export function blocksBuilderEditAppClick(params: blocksBuilderEditAppClickParams): LogObject<blocksBuilderEditAppClickParams> {
  throw new Error('blocksBuilderEditAppClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryLoaded' event (evid: 3120)
 *
 * Event description: Fired when App history is loaded
 *
 * @param {appHistoryLoadedParams} params - The parameters for this event
 * @return {LogObject<appHistoryLoadedParams>} LogObject<appHistoryLoadedParams>
 */
export function appHistoryLoaded(params: appHistoryLoadedParams): LogObject<appHistoryLoadedParams> {
  throw new Error('appHistoryLoaded cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'multilingualAddLanguagesClick' event (evid: 3111)
 *
 * Event description: event is fired when the user clicks on "add languages" in the multilingual control
 *
 * @param {multilingualAddLanguagesClickParams} params - The parameters for this event
 * @return {LogObject<multilingualAddLanguagesClickParams>} LogObject<multilingualAddLanguagesClickParams>
 */
export function multilingualAddLanguagesClick(params: multilingualAddLanguagesClickParams): LogObject<multilingualAddLanguagesClickParams> {
  throw new Error('multilingualAddLanguagesClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageEditPropertyClick' event (evid: 3019)
 *
 * Event description: user click edit to edit a property
 *
 * @param {widgetApiManageEditPropertyClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageEditPropertyClickParams>} LogObject<widgetApiManageEditPropertyClickParams>
 */
export function widgetApiManageEditPropertyClick(params: widgetApiManageEditPropertyClickParams): LogObject<widgetApiManageEditPropertyClickParams> {
  throw new Error('widgetApiManageEditPropertyClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'popUpOpened' event (evid: 3032)
 *
 * Event description: Pop Up Opened
 *
 * @param {popUpOpenedParams} params - The parameters for this event
 * @return {LogObject<popUpOpenedParams>} LogObject<popUpOpenedParams>
 */
export function popUpOpened(params: popUpOpenedParams): LogObject<popUpOpenedParams> {
  throw new Error('popUpOpened cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageUpdateEvent' event (evid: 3025)
 *
 * Event description: user click Save to save an edited event (in edit event tab)
 *
 * @param {widgetApiManageUpdateEventParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageUpdateEventParams>} LogObject<widgetApiManageUpdateEventParams>
 */
export function widgetApiManageUpdateEvent(params: widgetApiManageUpdateEventParams): LogObject<widgetApiManageUpdateEventParams> {
  throw new Error('widgetApiManageUpdateEvent cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'openExistingApp' event (evid: 3106)
 *
 * Event description: event is fired when a user clicks on one of the apps in the open an app modal
 *
 * @param {openExistingAppParams} params - The parameters for this event
 * @return {LogObject<openExistingAppParams>} LogObject<openExistingAppParams>
 */
export function openExistingApp(params: openExistingAppParams): LogObject<openExistingAppParams> {
  throw new Error('openExistingApp cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'dashboardPagesCreateAppDashboard' event (evid: 3113)
 *
 * Event description: Event is fired when the user clicks on one the buttons in the dashboard window from left tree
 *
 * @param {dashboardPagesCreateAppDashboardParams} params - The parameters for this event
 * @return {LogObject<dashboardPagesCreateAppDashboardParams>} LogObject<dashboardPagesCreateAppDashboardParams>
 */
export function dashboardPagesCreateAppDashboard(params: dashboardPagesCreateAppDashboardParams): LogObject<dashboardPagesCreateAppDashboardParams> {
  throw new Error('dashboardPagesCreateAppDashboard cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'designCustomColor' event (evid: 3040)
 *
 * Event description: UnLinked Colors Click in Color Picker Panel
 *
 * @param {designCustomColorParams} params - The parameters for this event
 * @return {LogObject<designCustomColorParams>} LogObject<designCustomColorParams>
 */
export function designCustomColor(params: designCustomColorParams): LogObject<designCustomColorParams> {
  throw new Error('designCustomColor cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addWidgetIntoWidgetSuccess' event (evid: 3035)
 *
 * Event description: Add Widget into Widget: success
 *
 * @param {addWidgetIntoWidgetSuccessParams} params - The parameters for this event
 * @return {LogObject<addWidgetIntoWidgetSuccessParams>} LogObject<addWidgetIntoWidgetSuccessParams>
 */
export function addWidgetIntoWidgetSuccess(params: addWidgetIntoWidgetSuccessParams): LogObject<addWidgetIntoWidgetSuccessParams> {
  throw new Error('addWidgetIntoWidgetSuccess cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'deprecatedComplexSelector' event (evid: 3134)
 *
 * Event description: Deprecated complex selector was used in user velo code
 *
 * @param {deprecatedComplexSelectorParams} params - The parameters for this event
 * @return {LogObject<deprecatedComplexSelectorParams>} LogObject<deprecatedComplexSelectorParams>
 */
export function deprecatedComplexSelector(params: deprecatedComplexSelectorParams): LogObject<deprecatedComplexSelectorParams> {
  throw new Error('deprecatedComplexSelector cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksCreatePackageApiCall' event (evid: 3065)
 *
 * Event description: This event should be sent every time we opening Blocks for creating a package
 *
 * @param {blocksCreatePackageApiCallParams} params - The parameters for this event
 * @return {LogObject<blocksCreatePackageApiCallParams>} LogObject<blocksCreatePackageApiCallParams>
 */
export function blocksCreatePackageApiCall(params: blocksCreatePackageApiCallParams): LogObject<blocksCreatePackageApiCallParams> {
  throw new Error('blocksCreatePackageApiCall cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appApiReferenceClick' event (evid: 3063)
 *
 * Event description: App API Reference click (three dots menu)
 *
 * @param {appApiReferenceClickParams} params - The parameters for this event
 * @return {LogObject<appApiReferenceClickParams>} LogObject<appApiReferenceClickParams>
 */
export function appApiReferenceClick(params: appApiReferenceClickParams): LogObject<appApiReferenceClickParams> {
  throw new Error('appApiReferenceClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetWidgetRenamed' event (evid: 3010)
 *
 * Event description: widget is Renamed successfully
 *
 * @param {blocksWidgetWidgetRenamedParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetWidgetRenamedParams>} LogObject<blocksWidgetWidgetRenamedParams>
 */
export function blocksWidgetWidgetRenamed(params: blocksWidgetWidgetRenamedParams): LogObject<blocksWidgetWidgetRenamedParams> {
  throw new Error('blocksWidgetWidgetRenamed cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'multilingualLanguageAddedSuccessfully' event (evid: 3108)
 *
 * Event description: event is fired when the installation of multilingual to blocks completed successfully
 *
 * @param {multilingualLanguageAddedSuccessfullyParams} params - The parameters for this event
 * @return {LogObject<multilingualLanguageAddedSuccessfullyParams>} LogObject<multilingualLanguageAddedSuccessfullyParams>
 */
export function multilingualLanguageAddedSuccessfully(params: multilingualLanguageAddedSuccessfullyParams): LogObject<multilingualLanguageAddedSuccessfullyParams> {
  throw new Error('multilingualLanguageAddedSuccessfully cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationEditDesignVariableChangeLinkedPropertyClick' event (evid: 3099)
 *
 * Event description: Layout customization: fires once a user clicks on change linked property inside the edit mode
 *
 * @param {layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams>} LogObject<layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams>
 */
export function layoutCustomizationEditDesignVariableChangeLinkedPropertyClick(params: layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams): LogObject<layoutCustomizationEditDesignVariableChangeLinkedPropertyClickParams> {
  throw new Error('layoutCustomizationEditDesignVariableChangeLinkedPropertyClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetThreeDotsMenuClick' event (evid: 3008)
 *
 * Event description: User Click to open Three dots menu
 *
 * @param {blocksWidgetThreeDotsMenuClickParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetThreeDotsMenuClickParams>} LogObject<blocksWidgetThreeDotsMenuClickParams>
 */
export function blocksWidgetThreeDotsMenuClick(params: blocksWidgetThreeDotsMenuClickParams): LogObject<blocksWidgetThreeDotsMenuClickParams> {
  throw new Error('blocksWidgetThreeDotsMenuClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'accessibilityAttributeChanged' event (evid: 3074)
 *
 * Event description: similar to 38:927 (sending it on 'add' - after adding new attribute and 'save' - after editing)
 *
 * @param {accessibilityAttributeChangedParams} params - The parameters for this event
 * @return {LogObject<accessibilityAttributeChangedParams>} LogObject<accessibilityAttributeChangedParams>
 */
export function accessibilityAttributeChanged(params: accessibilityAttributeChangedParams): LogObject<accessibilityAttributeChangedParams> {
  throw new Error('accessibilityAttributeChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetAddWidget' event (evid: 3007)
 *
 * Event description: User Click Plus / Section WIdget / Container Widget
 *
 * @param {blocksWidgetAddWidgetParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetAddWidgetParams>} LogObject<blocksWidgetAddWidgetParams>
 */
export function blocksWidgetAddWidget(params: blocksWidgetAddWidgetParams): LogObject<blocksWidgetAddWidgetParams> {
  throw new Error('blocksWidgetAddWidget cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryAppStructurePanelClick' event (evid: 3125)
 *
 * Event description: Fired when User clicks on a particulat element/file to review in the App structure panel
 *
 * @param {appHistoryAppStructurePanelClickParams} params - The parameters for this event
 * @return {LogObject<appHistoryAppStructurePanelClickParams>} LogObject<appHistoryAppStructurePanelClickParams>
 */
export function appHistoryAppStructurePanelClick(params: appHistoryAppStructurePanelClickParams): LogObject<appHistoryAppStructurePanelClickParams> {
  throw new Error('appHistoryAppStructurePanelClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetThreeDotsMenuActionClick' event (evid: 3009)
 *
 * Event description: User Click Duplicate / rename / delete in Widget Three Doots Menu
 *
 * @param {blocksWidgetThreeDotsMenuActionClickParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetThreeDotsMenuActionClickParams>} LogObject<blocksWidgetThreeDotsMenuActionClickParams>
 */
export function blocksWidgetThreeDotsMenuActionClick(params: blocksWidgetThreeDotsMenuActionClickParams): LogObject<blocksWidgetThreeDotsMenuActionClickParams> {
  throw new Error('blocksWidgetThreeDotsMenuActionClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderAddElementClick' event (evid: 3056)
 *
 * Event description: Panel Builder - Add Element Click
 *
 * @param {panelBuilderAddElementClickParams} params - The parameters for this event
 * @return {LogObject<panelBuilderAddElementClickParams>} LogObject<panelBuilderAddElementClickParams>
 */
export function panelBuilderAddElementClick(params: panelBuilderAddElementClickParams): LogObject<panelBuilderAddElementClickParams> {
  throw new Error('panelBuilderAddElementClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'presetDuplicated' event (evid: 3052)
 *
 * Event description: preset was Duplicated successfully
 *
 * @param {presetDuplicatedParams} params - The parameters for this event
 * @return {LogObject<presetDuplicatedParams>} LogObject<presetDuplicatedParams>
 */
export function presetDuplicated(params: presetDuplicatedParams): LogObject<presetDuplicatedParams> {
  throw new Error('presetDuplicated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationAddDesignVariableClick' event (evid: 3078)
 *
 * Event description: Layout customization: fires when a user clicks on adding a new design variable to the widget
 *
 * @param {layoutCustomizationAddDesignVariableClickParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationAddDesignVariableClickParams>} LogObject<layoutCustomizationAddDesignVariableClickParams>
 */
export function layoutCustomizationAddDesignVariableClick(params: layoutCustomizationAddDesignVariableClickParams): LogObject<layoutCustomizationAddDesignVariableClickParams> {
  throw new Error('layoutCustomizationAddDesignVariableClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryVersionSelected' event (evid: 3122)
 *
 * Event description: Fired when User selects an app version to review from version side panel
 *
 * @param {appHistoryVersionSelectedParams} params - The parameters for this event
 * @return {LogObject<appHistoryVersionSelectedParams>} LogObject<appHistoryVersionSelectedParams>
 */
export function appHistoryVersionSelected(params: appHistoryVersionSelectedParams): LogObject<appHistoryVersionSelectedParams> {
  throw new Error('appHistoryVersionSelected cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'switchWorkspace' event (evid: 3131)
 *
 * Event description: BI event indicating click on "Switch workspaces" on open an app modal
 *
 * @param {switchWorkspaceParams} params - The parameters for this event
 * @return {LogObject<switchWorkspaceParams>} LogObject<switchWorkspaceParams>
 */
export function switchWorkspace(params: switchWorkspaceParams): LogObject<switchWorkspaceParams> {
  throw new Error('switchWorkspace cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configAddActionButtonClick' event (evid: 3043)
 *
 * Event description: Config - Add Action Button Click
 *
 * @param {configAddActionButtonClickParams} params - The parameters for this event
 * @return {LogObject<configAddActionButtonClickParams>} LogObject<configAddActionButtonClickParams>
 */
export function configAddActionButtonClick(params: configAddActionButtonClickParams): LogObject<configAddActionButtonClickParams> {
  throw new Error('configAddActionButtonClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'welcomeScreenSeeAllAppsClick' event (evid: 3105)
 *
 * Event description: event is fired when a user clicks on see all apps button in the welcome screen page
 *
 * @param {welcomeScreenSeeAllAppsClickParams} params - The parameters for this event
 * @return {LogObject<welcomeScreenSeeAllAppsClickParams>} LogObject<welcomeScreenSeeAllAppsClickParams>
 */
export function welcomeScreenSeeAllAppsClick(params: welcomeScreenSeeAllAppsClickParams): LogObject<welcomeScreenSeeAllAppsClickParams> {
  throw new Error('welcomeScreenSeeAllAppsClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksPanelCtaClick' event (evid: 3128)
 *
 * Event description: Module: panel. Flow: panel is closed. E.g., edit, app panel ,layer panel It doesn't include popup dialogs
 * . 
 *
 * @param {blocksPanelCtaClickParams} params - The parameters for this event
 * @return {LogObject<blocksPanelCtaClickParams>} LogObject<blocksPanelCtaClickParams>
 */
export function blocksPanelCtaClick(params: blocksPanelCtaClickParams): LogObject<blocksPanelCtaClickParams> {
  throw new Error('blocksPanelCtaClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'popUpClicked' event (evid: 3033)
 *
 * Event description: Pop Up Clicked
 *
 * @param {popUpClickedParams} params - The parameters for this event
 * @return {LogObject<popUpClickedParams>} LogObject<popUpClickedParams>
 */
export function popUpClicked(params: popUpClickedParams): LogObject<popUpClickedParams> {
  throw new Error('popUpClicked cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationLinkToMoreProperties' event (evid: 3086)
 *
 * Event description: Layout customization: fires when a user clicks "link to more properties" button
 *
 * @param {layoutCustomizationLinkToMorePropertiesParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationLinkToMorePropertiesParams>} LogObject<layoutCustomizationLinkToMorePropertiesParams>
 */
export function layoutCustomizationLinkToMoreProperties(params: layoutCustomizationLinkToMorePropertiesParams): LogObject<layoutCustomizationLinkToMorePropertiesParams> {
  throw new Error('layoutCustomizationLinkToMoreProperties cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddPropertyToCustomType' event (evid: 3049)
 *
 * Event description: user click Create to add a property (in a App Custom Type panel)
 *
 * @param {widgetApiManageAddPropertyToCustomTypeParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddPropertyToCustomTypeParams>} LogObject<widgetApiManageAddPropertyToCustomTypeParams>
 */
export function widgetApiManageAddPropertyToCustomType(params: widgetApiManageAddPropertyToCustomTypeParams): LogObject<widgetApiManageAddPropertyToCustomTypeParams> {
  throw new Error('widgetApiManageAddPropertyToCustomType cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageUpdateProperty' event (evid: 3020)
 *
 * Event description: user click Save to save an edited property (in edit property tab)
 *
 * @param {widgetApiManageUpdatePropertyParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageUpdatePropertyParams>} LogObject<widgetApiManageUpdatePropertyParams>
 */
export function widgetApiManageUpdateProperty(params: widgetApiManageUpdatePropertyParams): LogObject<widgetApiManageUpdatePropertyParams> {
  throw new Error('widgetApiManageUpdateProperty cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'topBarTabsClick' event (evid: 3041)
 *
 * Event description: topBarTabs Click
 *
 * @param {topBarTabsClickParams} params - The parameters for this event
 * @return {LogObject<topBarTabsClickParams>} LogObject<topBarTabsClickParams>
 */
export function topBarTabsClick(params: topBarTabsClickParams): LogObject<topBarTabsClickParams> {
  throw new Error('topBarTabsClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configManifestBehaviorChanged' event (evid: 3047)
 *
 * Event description: Config - Manifest Behavior Changed
 *
 * @param {configManifestBehaviorChangedParams} params - The parameters for this event
 * @return {LogObject<configManifestBehaviorChangedParams>} LogObject<configManifestBehaviorChangedParams>
 */
export function configManifestBehaviorChanged(params: configManifestBehaviorChangedParams): LogObject<configManifestBehaviorChangedParams> {
  throw new Error('configManifestBehaviorChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetFromWidgetLibrariesAdded' event (evid: 3070)
 *
 * Event description: Widget from Widget Libraries added
 *
 * @param {widgetFromWidgetLibrariesAddedParams} params - The parameters for this event
 * @return {LogObject<widgetFromWidgetLibrariesAddedParams>} LogObject<widgetFromWidgetLibrariesAddedParams>
 */
export function widgetFromWidgetLibrariesAdded(params: widgetFromWidgetLibrariesAddedParams): LogObject<widgetFromWidgetLibrariesAddedParams> {
  throw new Error('widgetFromWidgetLibrariesAdded cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationLinkVariableToComponent' event (evid: 3079)
 *
 * Event description: Layout customization: fires when a user clicks on linking a new design variable to a component
 *
 * @param {layoutCustomizationLinkVariableToComponentParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationLinkVariableToComponentParams>} LogObject<layoutCustomizationLinkVariableToComponentParams>
 */
export function layoutCustomizationLinkVariableToComponent(params: layoutCustomizationLinkVariableToComponentParams): LogObject<layoutCustomizationLinkVariableToComponentParams> {
  throw new Error('layoutCustomizationLinkVariableToComponent cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addElementsViewWixDesignSystem' event (evid: 3133)
 *
 * Event description: BI event indicating click on "View Wix Design System" on Add Elements section on Dashboard tab
 *
 * @param {addElementsViewWixDesignSystemParams} params - The parameters for this event
 * @return {LogObject<addElementsViewWixDesignSystemParams>} LogObject<addElementsViewWixDesignSystemParams>
 */
export function addElementsViewWixDesignSystem(params: addElementsViewWixDesignSystemParams): LogObject<addElementsViewWixDesignSystemParams> {
  throw new Error('addElementsViewWixDesignSystem cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderChooseElementToAdd' event (evid: 3057)
 *
 * Event description: Panel Builder - Choose Element to add
 *
 * @param {panelBuilderChooseElementToAddParams} params - The parameters for this event
 * @return {LogObject<panelBuilderChooseElementToAddParams>} LogObject<panelBuilderChooseElementToAddParams>
 */
export function panelBuilderChooseElementToAdd(params: panelBuilderChooseElementToAddParams): LogObject<panelBuilderChooseElementToAddParams> {
  throw new Error('panelBuilderChooseElementToAdd cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addAppDependencyClick' event (evid: 3061)
 *
 * Event description: Add App Dependency click
 *
 * @param {addAppDependencyClickParams} params - The parameters for this event
 * @return {LogObject<addAppDependencyClickParams>} LogObject<addAppDependencyClickParams>
 */
export function addAppDependencyClick(params: addAppDependencyClickParams): LogObject<addAppDependencyClickParams> {
  throw new Error('addAppDependencyClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'designLinkedToSiteThemeClick' event (evid: 3039)
 *
 * Event description: Linked to Site Theme Click in Color Picker Panel
 *
 * @param {designLinkedToSiteThemeClickParams} params - The parameters for this event
 * @return {LogObject<designLinkedToSiteThemeClickParams>} LogObject<designLinkedToSiteThemeClickParams>
 */
export function designLinkedToSiteThemeClick(params: designLinkedToSiteThemeClickParams): LogObject<designLinkedToSiteThemeClickParams> {
  throw new Error('designLinkedToSiteThemeClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationDesignVariableDeleted' event (evid: 3083)
 *
 * Event description: Layout customization: fires when a user removes a design variable
 *
 * @param {layoutCustomizationDesignVariableDeletedParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationDesignVariableDeletedParams>} LogObject<layoutCustomizationDesignVariableDeletedParams>
 */
export function layoutCustomizationDesignVariableDeleted(params: layoutCustomizationDesignVariableDeletedParams): LogObject<layoutCustomizationDesignVariableDeletedParams> {
  throw new Error('layoutCustomizationDesignVariableDeleted cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'designThemeOnPreviewChosen' event (evid: 3038)
 *
 * Event description: user choose any Theme to test it in a Preview mode
 *
 * @param {designThemeOnPreviewChosenParams} params - The parameters for this event
 * @return {LogObject<designThemeOnPreviewChosenParams>} LogObject<designThemeOnPreviewChosenParams>
 */
export function designThemeOnPreviewChosen(params: designThemeOnPreviewChosenParams): LogObject<designThemeOnPreviewChosenParams> {
  throw new Error('designThemeOnPreviewChosen cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'gettingStartedClick' event (evid: 3093)
 *
 * Event description: event is fired when a user chooses how to start creating the app in the getting started empty state
 *
 * @param {gettingStartedClickParams} params - The parameters for this event
 * @return {LogObject<gettingStartedClickParams>} LogObject<gettingStartedClickParams>
 */
export function gettingStartedClick(params: gettingStartedClickParams): LogObject<gettingStartedClickParams> {
  throw new Error('gettingStartedClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageEditEventClick' event (evid: 3024)
 *
 * Event description: user click edit to edit an event
 *
 * @param {widgetApiManageEditEventClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageEditEventClickParams>} LogObject<widgetApiManageEditEventClickParams>
 */
export function widgetApiManageEditEventClick(params: widgetApiManageEditEventClickParams): LogObject<widgetApiManageEditEventClickParams> {
  throw new Error('widgetApiManageEditEventClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiVisibilityChanged' event (evid: 3013)
 *
 * Event description: start to show api panel or stop showing it
 *
 * @param {widgetApiVisibilityChangedParams} params - The parameters for this event
 * @return {LogObject<widgetApiVisibilityChangedParams>} LogObject<widgetApiVisibilityChangedParams>
 */
export function widgetApiVisibilityChanged(params: widgetApiVisibilityChangedParams): LogObject<widgetApiVisibilityChangedParams> {
  throw new Error('widgetApiVisibilityChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appNameInTheTopBarClick' event (evid: 3068)
 *
 * Event description: fires when clicking on the app name on the top bar
 *
 * @param {appNameInTheTopBarClickParams} params - The parameters for this event
 * @return {LogObject<appNameInTheTopBarClickParams>} LogObject<appNameInTheTopBarClickParams>
 */
export function appNameInTheTopBarClick(params: appNameInTheTopBarClickParams): LogObject<appNameInTheTopBarClickParams> {
  throw new Error('appNameInTheTopBarClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryLoadMoreClick' event (evid: 3127)
 *
 * Event description: Fires when Load more button in Version selection sidebar (right) is being clicked.
 *
 * @param {appHistoryLoadMoreClickParams} params - The parameters for this event
 * @return {LogObject<appHistoryLoadMoreClickParams>} LogObject<appHistoryLoadMoreClickParams>
 */
export function appHistoryLoadMoreClick(params: appHistoryLoadMoreClickParams): LogObject<appHistoryLoadMoreClickParams> {
  throw new Error('appHistoryLoadMoreClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'shareableUrlCreationResult' event (evid: 3119)
 *
 * Event description: BI event fired after the shareable url is generated or the url creation process fails
 *
 * @param {shareableUrlCreationResultParams} params - The parameters for this event
 * @return {LogObject<shareableUrlCreationResultParams>} LogObject<shareableUrlCreationResultParams>
 */
export function shareableUrlCreationResult(params: shareableUrlCreationResultParams): LogObject<shareableUrlCreationResultParams> {
  throw new Error('shareableUrlCreationResult cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderBuildSuccess' event (evid: 3005)
 *
 * Event description: App built successfuly.
 *
 * @param {blocksBuilderBuildSuccessParams} params - The parameters for this event
 * @return {LogObject<blocksBuilderBuildSuccessParams>} LogObject<blocksBuilderBuildSuccessParams>
 */
export function blocksBuilderBuildSuccess(params: blocksBuilderBuildSuccessParams): LogObject<blocksBuilderBuildSuccessParams> {
  throw new Error('blocksBuilderBuildSuccess cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'removeAppDependency' event (evid: 3064)
 *
 * Event description: Remove App Dependency (three dots menu)
 *
 * @param {removeAppDependencyParams} params - The parameters for this event
 * @return {LogObject<removeAppDependencyParams>} LogObject<removeAppDependencyParams>
 */
export function removeAppDependency(params: removeAppDependencyParams): LogObject<removeAppDependencyParams> {
  throw new Error('removeAppDependency cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksAppCreated' event (evid: 3096)
 *
 * Event description: Fires when an app id is created for the first time
 *
 * @param {blocksAppCreatedParams} params - The parameters for this event
 * @return {LogObject<blocksAppCreatedParams>} LogObject<blocksAppCreatedParams>
 */
export function blocksAppCreated(params: blocksAppCreatedParams): LogObject<blocksAppCreatedParams> {
  throw new Error('blocksAppCreated cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryRestoreVersionIntent' event (evid: 3123)
 *
 * Event description: Fired when user tries/confirms Restore of a version
 *
 * @param {appHistoryRestoreVersionIntentParams} params - The parameters for this event
 * @return {LogObject<appHistoryRestoreVersionIntentParams>} LogObject<appHistoryRestoreVersionIntentParams>
 */
export function appHistoryRestoreVersionIntent(params: appHistoryRestoreVersionIntentParams): LogObject<appHistoryRestoreVersionIntentParams> {
  throw new Error('appHistoryRestoreVersionIntent cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddFunctionClick' event (evid: 3027)
 *
 * Event description: user click to add function
 *
 * @param {widgetApiManageAddFunctionClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddFunctionClickParams>} LogObject<widgetApiManageAddFunctionClickParams>
 */
export function widgetApiManageAddFunctionClick(params: widgetApiManageAddFunctionClickParams): LogObject<widgetApiManageAddFunctionClickParams> {
  throw new Error('widgetApiManageAddFunctionClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationDesignVariableNextClick' event (evid: 3098)
 *
 * Event description: Layout customization: fires when a user clicks the next button in the process of defining the design variable
 *
 * @param {layoutCustomizationDesignVariableNextClickParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationDesignVariableNextClickParams>} LogObject<layoutCustomizationDesignVariableNextClickParams>
 */
export function layoutCustomizationDesignVariableNextClick(params: layoutCustomizationDesignVariableNextClickParams): LogObject<layoutCustomizationDesignVariableNextClickParams> {
  throw new Error('layoutCustomizationDesignVariableNextClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderPanelPropertiesChanged' event (evid: 3060)
 *
 * Event description: Panel Builder - Panel Properties Changed
 *
 * @param {panelBuilderPanelPropertiesChangedParams} params - The parameters for this event
 * @return {LogObject<panelBuilderPanelPropertiesChangedParams>} LogObject<panelBuilderPanelPropertiesChangedParams>
 */
export function panelBuilderPanelPropertiesChanged(params: panelBuilderPanelPropertiesChangedParams): LogObject<panelBuilderPanelPropertiesChangedParams> {
  throw new Error('panelBuilderPanelPropertiesChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'savePackageSuccess' event (evid: 3069)
 *
 * Event description: event for having relation between app_def_id and msid
 *
 * @param {savePackageSuccessParams} params - The parameters for this event
 * @return {LogObject<savePackageSuccessParams>} LogObject<savePackageSuccessParams>
 */
export function savePackageSuccess(params: savePackageSuccessParams): LogObject<savePackageSuccessParams> {
  throw new Error('savePackageSuccess cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationEditDesignVariablePresetValuesEdited' event (evid: 3084)
 *
 * Event description: Layout customization: fires once a user changes the preset values inside the edit panel mode
 *
 * @param {layoutCustomizationEditDesignVariablePresetValuesEditedParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationEditDesignVariablePresetValuesEditedParams>} LogObject<layoutCustomizationEditDesignVariablePresetValuesEditedParams>
 */
export function layoutCustomizationEditDesignVariablePresetValuesEdited(params: layoutCustomizationEditDesignVariablePresetValuesEditedParams): LogObject<layoutCustomizationEditDesignVariablePresetValuesEditedParams> {
  throw new Error('layoutCustomizationEditDesignVariablePresetValuesEdited cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddEventClick' event (evid: 3022)
 *
 * Event description: user click to add event
 *
 * @param {widgetApiManageAddEventClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddEventClickParams>} LogObject<widgetApiManageAddEventClickParams>
 */
export function widgetApiManageAddEventClick(params: widgetApiManageAddEventClickParams): LogObject<widgetApiManageAddEventClickParams> {
  throw new Error('widgetApiManageAddEventClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'presetDeleted' event (evid: 3053)
 *
 * Event description: widget is Deleted successfully
 *
 * @param {presetDeletedParams} params - The parameters for this event
 * @return {LogObject<presetDeletedParams>} LogObject<presetDeletedParams>
 */
export function presetDeleted(params: presetDeletedParams): LogObject<presetDeletedParams> {
  throw new Error('presetDeleted cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderDeleteElement' event (evid: 3058)
 *
 * Event description: Panel Builder - Delete Element
 *
 * @param {panelBuilderDeleteElementParams} params - The parameters for this event
 * @return {LogObject<panelBuilderDeleteElementParams>} LogObject<panelBuilderDeleteElementParams>
 */
export function panelBuilderDeleteElement(params: panelBuilderDeleteElementParams): LogObject<panelBuilderDeleteElementParams> {
  throw new Error('panelBuilderDeleteElement cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'shareableUrlButtonClick' event (evid: 3118)
 *
 * Event description: Event is fired on any button clicked on shareable url related modals
 *
 * @param {shareableUrlButtonClickParams} params - The parameters for this event
 * @return {LogObject<shareableUrlButtonClickParams>} LogObject<shareableUrlButtonClickParams>
 */
export function shareableUrlButtonClick(params: shareableUrlButtonClickParams): LogObject<shareableUrlButtonClickParams> {
  throw new Error('shareableUrlButtonClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'layoutCustomizationDesignVariableRenamed' event (evid: 3082)
 *
 * Event description: Layout customization: fires when a user renaming the design variable
 *
 * @param {layoutCustomizationDesignVariableRenamedParams} params - The parameters for this event
 * @return {LogObject<layoutCustomizationDesignVariableRenamedParams>} LogObject<layoutCustomizationDesignVariableRenamedParams>
 */
export function layoutCustomizationDesignVariableRenamed(params: layoutCustomizationDesignVariableRenamedParams): LogObject<layoutCustomizationDesignVariableRenamedParams> {
  throw new Error('layoutCustomizationDesignVariableRenamed cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddEvent' event (evid: 3023)
 *
 * Event description: user click create to create an event
 *
 * @param {widgetApiManageAddEventParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddEventParams>} LogObject<widgetApiManageAddEventParams>
 */
export function widgetApiManageAddEvent(params: widgetApiManageAddEventParams): LogObject<widgetApiManageAddEventParams> {
  throw new Error('widgetApiManageAddEvent cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderReorderElement' event (evid: 3059)
 *
 * Event description: Panel Builder - Reorder Element
 *
 * @param {panelBuilderReorderElementParams} params - The parameters for this event
 * @return {LogObject<panelBuilderReorderElementParams>} LogObject<panelBuilderReorderElementParams>
 */
export function panelBuilderReorderElement(params: panelBuilderReorderElementParams): LogObject<panelBuilderReorderElementParams> {
  throw new Error('panelBuilderReorderElement cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddPropertyToCustomTypeClick' event (evid: 3048)
 *
 * Event description: user click to add property in Custom type Panel
 *
 * @param {widgetApiManageAddPropertyToCustomTypeClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddPropertyToCustomTypeClickParams>} LogObject<widgetApiManageAddPropertyToCustomTypeClickParams>
 */
export function widgetApiManageAddPropertyToCustomTypeClick(params: widgetApiManageAddPropertyToCustomTypeClickParams): LogObject<widgetApiManageAddPropertyToCustomTypeClickParams> {
  throw new Error('widgetApiManageAddPropertyToCustomTypeClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'previewPresetSelect' event (evid: 3054)
 *
 * Event description: user changing Preset in Preview mode
 *
 * @param {previewPresetSelectParams} params - The parameters for this event
 * @return {LogObject<previewPresetSelectParams>} LogObject<previewPresetSelectParams>
 */
export function previewPresetSelect(params: previewPresetSelectParams): LogObject<previewPresetSelectParams> {
  throw new Error('previewPresetSelect cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'panelBuilderAddElementBrowseAllClick' event (evid: 3095)
 *
 * Event description: Panel Builder - Add Element - Browse All Click
 *
 * @param {panelBuilderAddElementBrowseAllClickParams} params - The parameters for this event
 * @return {LogObject<panelBuilderAddElementBrowseAllClickParams>} LogObject<panelBuilderAddElementBrowseAllClickParams>
 */
export function panelBuilderAddElementBrowseAllClick(params: panelBuilderAddElementBrowseAllClickParams): LogObject<panelBuilderAddElementBrowseAllClickParams> {
  throw new Error('panelBuilderAddElementBrowseAllClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'configManifestDisplayNameChanged' event (evid: 3046)
 *
 * Event description: Config - Manifest Display Name Changed
 *
 * @param {configManifestDisplayNameChangedParams} params - The parameters for this event
 * @return {LogObject<configManifestDisplayNameChangedParams>} LogObject<configManifestDisplayNameChangedParams>
 */
export function configManifestDisplayNameChanged(params: configManifestDisplayNameChangedParams): LogObject<configManifestDisplayNameChangedParams> {
  throw new Error('configManifestDisplayNameChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'propertiesChanged' event (evid: 3016)
 *
 * Event description: any of the properties was changed (in API Preveiw)
 *
 * @param {propertiesChangedParams} params - The parameters for this event
 * @return {LogObject<propertiesChangedParams>} LogObject<propertiesChangedParams>
 */
export function propertiesChanged(params: propertiesChangedParams): LogObject<propertiesChangedParams> {
  throw new Error('propertiesChanged cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageAddProperty' event (evid: 3018)
 *
 * Event description: user click Create to add a property (in a new property tab)
 *
 * @param {widgetApiManageAddPropertyParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageAddPropertyParams>} LogObject<widgetApiManageAddPropertyParams>
 */
export function widgetApiManageAddProperty(params: widgetApiManageAddPropertyParams): LogObject<widgetApiManageAddPropertyParams> {
  throw new Error('widgetApiManageAddProperty cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageCustomTypeActionClick' event (evid: 3030)
 *
 * Event description: Widget API Manage - custom type action click
 *
 * @param {widgetApiManageCustomTypeActionClickParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageCustomTypeActionClickParams>} LogObject<widgetApiManageCustomTypeActionClickParams>
 */
export function widgetApiManageCustomTypeActionClick(params: widgetApiManageCustomTypeActionClickParams): LogObject<widgetApiManageCustomTypeActionClickParams> {
  throw new Error('widgetApiManageCustomTypeActionClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksPanelPanelClosed' event (evid: 3002)
 *
 * Event description: Module: panel. Flow: panel is closed. E.g., edit, app panel ,layer panel It doesn't include popup dialogs
 * . 
 *
 * @param {blocksPanelPanelClosedParams} params - The parameters for this event
 * @return {LogObject<blocksPanelPanelClosedParams>} LogObject<blocksPanelPanelClosedParams>
 */
export function blocksPanelPanelClosed(params: blocksPanelPanelClosedParams): LogObject<blocksPanelPanelClosedParams> {
  throw new Error('blocksPanelPanelClosed cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'mainActionSettingsConfiguration' event (evid: 3116)
 *
 * Event description: Changing the action that should open in Main Action Settings or changing the label name
 *
 * @param {mainActionSettingsConfigurationParams} params - The parameters for this event
 * @return {LogObject<mainActionSettingsConfigurationParams>} LogObject<mainActionSettingsConfigurationParams>
 */
export function mainActionSettingsConfiguration(params: mainActionSettingsConfigurationParams): LogObject<mainActionSettingsConfigurationParams> {
  throw new Error('mainActionSettingsConfiguration cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appDependencyChose' event (evid: 3062)
 *
 * Event description: user selected app from a list in Dependencies Manager
 *
 * @param {appDependencyChoseParams} params - The parameters for this event
 * @return {LogObject<appDependencyChoseParams>} LogObject<appDependencyChoseParams>
 */
export function appDependencyChose(params: appDependencyChoseParams): LogObject<appDependencyChoseParams> {
  throw new Error('appDependencyChose cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'welcomeScreenArticleClick' event (evid: 3104)
 *
 * Event description: event is fired when a user clicks on one of the articles in the welcome screen page
 *
 * @param {welcomeScreenArticleClickParams} params - The parameters for this event
 * @return {LogObject<welcomeScreenArticleClickParams>} LogObject<welcomeScreenArticleClickParams>
 */
export function welcomeScreenArticleClick(params: welcomeScreenArticleClickParams): LogObject<welcomeScreenArticleClickParams> {
  throw new Error('welcomeScreenArticleClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksPanelPanelLoaded' event (evid: 3001)
 *
 * Event description: Module: panel. Flow: panel is loaded. E.g., edit, add panel ,layer panel It doesn't include popup dialogs. 
 *
 * @param {blocksPanelPanelLoadedParams} params - The parameters for this event
 * @return {LogObject<blocksPanelPanelLoadedParams>} LogObject<blocksPanelPanelLoadedParams>
 */
export function blocksPanelPanelLoaded(params: blocksPanelPanelLoadedParams): LogObject<blocksPanelPanelLoadedParams> {
  throw new Error('blocksPanelPanelLoaded cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'designTestThemeClick' event (evid: 3037)
 *
 * Event description: user click Test Theme in a Preview mode
 *
 * @param {designTestThemeClickParams} params - The parameters for this event
 * @return {LogObject<designTestThemeClickParams>} LogObject<designTestThemeClickParams>
 */
export function designTestThemeClick(params: designTestThemeClickParams): LogObject<designTestThemeClickParams> {
  throw new Error('designTestThemeClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appHistoryRestoreVersionFailed' event (evid: 3126)
 *
 * Event description: Fires when historic version restoration fails
 *
 * @param {appHistoryRestoreVersionFailedParams} params - The parameters for this event
 * @return {LogObject<appHistoryRestoreVersionFailedParams>} LogObject<appHistoryRestoreVersionFailedParams>
 */
export function appHistoryRestoreVersionFailed(params: appHistoryRestoreVersionFailedParams): LogObject<appHistoryRestoreVersionFailedParams> {
  throw new Error('appHistoryRestoreVersionFailed cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'archiveApp' event (evid: 3076)
 *
 * Event description: Fires when clicking archive app from top bar menu: App --> Archive App
 *
 * @param {archiveAppParams} params - The parameters for this event
 * @return {LogObject<archiveAppParams>} LogObject<archiveAppParams>
 */
export function archiveApp(params: archiveAppParams): LogObject<archiveAppParams> {
  throw new Error('archiveApp cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'consumptionAddWidgetToPage' event (evid: 3036)
 *
 * Event description: User added widget to EditorX page
 *
 * @param {consumptionAddWidgetToPageParams} params - The parameters for this event
 * @return {LogObject<consumptionAddWidgetToPageParams>} LogObject<consumptionAddWidgetToPageParams>
 */
export function consumptionAddWidgetToPage(params: consumptionAddWidgetToPageParams): LogObject<consumptionAddWidgetToPageParams> {
  throw new Error('consumptionAddWidgetToPage cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'addPreset' event (evid: 3050)
 *
 * Event description: User Click to add new Preset
 *
 * @param {addPresetParams} params - The parameters for this event
 * @return {LogObject<addPresetParams>} LogObject<addPresetParams>
 */
export function addPreset(params: addPresetParams): LogObject<addPresetParams> {
  throw new Error('addPreset cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'appNamespaceTry' event (evid: 3102)
 *
 * Event description: event is fired when a user attempts to create a namespace for his app (needed when the app has code files or collections)
 *
 * @param {appNamespaceTryParams} params - The parameters for this event
 * @return {LogObject<appNamespaceTryParams>} LogObject<appNamespaceTryParams>
 */
export function appNamespaceTry(params: appNamespaceTryParams): LogObject<appNamespaceTryParams> {
  throw new Error('appNamespaceTry cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'welcomeScreenItemClick' event (evid: 3103)
 *
 * Event description: event is fired when a user clicks on one of the items in the welcome screen page
 *
 * @param {welcomeScreenItemClickParams} params - The parameters for this event
 * @return {LogObject<welcomeScreenItemClickParams>} LogObject<welcomeScreenItemClickParams>
 */
export function welcomeScreenItemClick(params: welcomeScreenItemClickParams): LogObject<welcomeScreenItemClickParams> {
  throw new Error('welcomeScreenItemClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'namespaceFailedPanelTryAgainClick' event (evid: 3097)
 *
 * Event description: The event is fired when the user clicks on the try again button, in a panel that opened letting the user know there was a problem with creating namespace
 *
 * @param {namespaceFailedPanelTryAgainClickParams} params - The parameters for this event
 * @return {LogObject<namespaceFailedPanelTryAgainClickParams>} LogObject<namespaceFailedPanelTryAgainClickParams>
 */
export function namespaceFailedPanelTryAgainClick(params: namespaceFailedPanelTryAgainClickParams): LogObject<namespaceFailedPanelTryAgainClickParams> {
  throw new Error('namespaceFailedPanelTryAgainClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'widgetApiManageDeleteProperty' event (evid: 3021)
 *
 * Event description: user click delete to delete a property
 *
 * @param {widgetApiManageDeletePropertyParams} params - The parameters for this event
 * @return {LogObject<widgetApiManageDeletePropertyParams>} LogObject<widgetApiManageDeletePropertyParams>
 */
export function widgetApiManageDeleteProperty(params: widgetApiManageDeletePropertyParams): LogObject<widgetApiManageDeletePropertyParams> {
  throw new Error('widgetApiManageDeleteProperty cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksWidgetWidgetDeleted' event (evid: 3012)
 *
 * Event description: widget is Deleted successfully
 *
 * @param {blocksWidgetWidgetDeletedParams} params - The parameters for this event
 * @return {LogObject<blocksWidgetWidgetDeletedParams>} LogObject<blocksWidgetWidgetDeletedParams>
 */
export function blocksWidgetWidgetDeleted(params: blocksWidgetWidgetDeletedParams): LogObject<blocksWidgetWidgetDeletedParams> {
  throw new Error('blocksWidgetWidgetDeleted cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'presetRenamed' event (evid: 3051)
 *
 * Event description: preset was Renamed successfully
 *
 * @param {presetRenamedParams} params - The parameters for this event
 * @return {LogObject<presetRenamedParams>} LogObject<presetRenamedParams>
 */
export function presetRenamed(params: presetRenamedParams): LogObject<presetRenamedParams> {
  throw new Error('presetRenamed cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'privateAppsInstallAppSuccess' event (evid: 4201)
 *
 * Event description: The event is fired once the installation of a Blocks app finishes successfully
 *
 * @param {privateAppsInstallAppSuccessParams} params - The parameters for this event
 * @return {LogObject<privateAppsInstallAppSuccessParams>} LogObject<privateAppsInstallAppSuccessParams>
 */
export function privateAppsInstallAppSuccess(params: privateAppsInstallAppSuccessParams): LogObject<privateAppsInstallAppSuccessParams> {
  throw new Error('privateAppsInstallAppSuccess cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'privateAppsInstallAppClick' event (evid: 4200)
 *
 * Event description: The event is fired once a user clicks on install a Blocks app
 *
 * @param {privateAppsInstallAppClickParams} params - The parameters for this event
 * @return {LogObject<privateAppsInstallAppClickParams>} LogObject<privateAppsInstallAppClickParams>
 */
export function privateAppsInstallAppClick(params: privateAppsInstallAppClickParams): LogObject<privateAppsInstallAppClickParams> {
  throw new Error('privateAppsInstallAppClick cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'actionSuccess' event (evid: 10103)
 *
 * Event description: fires when the build process completed successfully
 *
 * @param {actionSuccessParams} params - The parameters for this event
 * @return {LogObject<actionSuccessParams>} LogObject<actionSuccessParams>
 */
export function actionSuccess(params: actionSuccessParams): LogObject<actionSuccessParams> {
  throw new Error('actionSuccess cannot be used, reason: Event is not active in catalog v2');
}

/**
 * A function to create a log object for the 'blocksBuilderGetAppLinkClick' event (evid: 3004)
 *
 * Event description: user clicked on 'Get App Link' or 'Try Again'  inside AppSettings
 *
 * @param {blocksBuilderGetAppLinkClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {boolean} isSuccess - is_success
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} origin - origin
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<blocksBuilderGetAppLinkClickParams>} LogObject<blocksBuilderGetAppLinkClickParams>
 */
export function blocksBuilderGetAppLinkClick(params: blocksBuilderGetAppLinkClickParams): LogObject<blocksBuilderGetAppLinkClickParams> {
  return { evid: 3004, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'testApiPropertiesClick' event (evid: 3015)
 *
 * Event description: user click Test API Properties Click in a Preview mode
 *
 * @param {testApiPropertiesClickParams} params - The parameters for this event
 * @property {string} widgetId - widget_id
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<testApiPropertiesClickParams>} LogObject<testApiPropertiesClickParams>
 */
export function testApiPropertiesClick(params: testApiPropertiesClickParams): LogObject<testApiPropertiesClickParams> {
  return { evid: 3015, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'dropDownMenuClick' event (evid: 3028)
 *
 * Event description: user click DropDown
 *
 * @param {dropDownMenuClickParams} params - The parameters for this event
 * @property {string} widgetId - widget_id
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} state - state
 * @property {string} panel_name - panel_name
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} control_name - control_name
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<dropDownMenuClickParams>} LogObject<dropDownMenuClickParams>
 */
export function dropDownMenuClick(params: dropDownMenuClickParams): LogObject<dropDownMenuClickParams> {
  return { evid: 3028, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'toggleClick' event (evid: 3029)
 *
 * Event description: user click Toggle
 *
 * @param {toggleClickParams} params - The parameters for this event
 * @property {string} widgetId - widget_id
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} state - state
 * @property {string} panel_name - panel_name
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} control_name - control_name
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<toggleClickParams>} LogObject<toggleClickParams>
 */
export function toggleClick(params: toggleClickParams): LogObject<toggleClickParams> {
  return { evid: 3029, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'widgetApiManageEditCustomTypeClick' event (evid: 3031)
 *
 * Event description: Widget API Manage - edit custom type click
 *
 * @param {widgetApiManageEditCustomTypeClickParams} params - The parameters for this event
 * @property {string} widgetId - widget_id
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<widgetApiManageEditCustomTypeClickParams>} LogObject<widgetApiManageEditCustomTypeClickParams>
 */
export function widgetApiManageEditCustomTypeClick(params: widgetApiManageEditCustomTypeClickParams): LogObject<widgetApiManageEditCustomTypeClickParams> {
  return { evid: 3031, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'appLinkActions' event (evid: 3077)
 *
 * Event description: Fires when copying, deleting the app link
 *
 * @param {appLinkActionsParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} appName - app_name
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} target - target
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<appLinkActionsParams>} LogObject<appLinkActionsParams>
 */
export function appLinkActions(params: appLinkActionsParams): LogObject<appLinkActionsParams> {
  return { evid: 3077, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'leftBarClick' event (evid: 3092)
 *
 * Event description: event is fired when a user clicks on the left bar tabs
 *
 * @param {leftBarClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} target - target
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<leftBarClickParams>} LogObject<leftBarClickParams>
 */
export function leftBarClick(params: leftBarClickParams): LogObject<leftBarClickParams> {
  return { evid: 3092, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'multilingualOpenMultilingualControl' event (evid: 3109)
 *
 * Event description: event is fired when the user opens the multilingual control in the blocks workspace
 *
 * @param {multilingualOpenMultilingualControlParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<multilingualOpenMultilingualControlParams>} LogObject<multilingualOpenMultilingualControlParams>
 */
export function multilingualOpenMultilingualControl(params: multilingualOpenMultilingualControlParams): LogObject<multilingualOpenMultilingualControlParams> {
  return { evid: 3109, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'multilingualSwitchLanguage' event (evid: 3110)
 *
 * Event description: event is fired when the user switches the language in the multilingual control
 *
 * @param {multilingualSwitchLanguageParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} target_language - target_language
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<multilingualSwitchLanguageParams>} LogObject<multilingualSwitchLanguageParams>
 */
export function multilingualSwitchLanguage(params: multilingualSwitchLanguageParams): LogObject<multilingualSwitchLanguageParams> {
  return { evid: 3110, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'clickOnSaveLocalEditor' event (evid: 3112)
 *
 * Event description: Event is fired when the user clicks on "save" while he is in the local editor
 *
 * @param {clickOnSaveLocalEditorParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} repoName - repo_name
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} gitUserName - git_user_name
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<clickOnSaveLocalEditorParams>} LogObject<clickOnSaveLocalEditorParams>
 */
export function clickOnSaveLocalEditor(params: clickOnSaveLocalEditorParams): LogObject<clickOnSaveLocalEditorParams> {
  return { evid: 3112, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'blocksBuilderClickOnBuild' event (evid: 3115)
 *
 * Event description: Event is fired when the user clicks on build button in the stage
 *
 * @param {blocksBuilderClickOnBuildParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<blocksBuilderClickOnBuildParams>} LogObject<blocksBuilderClickOnBuildParams>
 */
export function blocksBuilderClickOnBuild(params: blocksBuilderClickOnBuildParams): LogObject<blocksBuilderClickOnBuildParams> {
  return { evid: 3115, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'appDashboardCopyToClipboard' event (evid: 3117)
 *
 * Event description: user clicked on copy to clipboard
 *
 * @param {appDashboardCopyToClipboardParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @property {string} action - action
 * @return {LogObject<appDashboardCopyToClipboardParams>} LogObject<appDashboardCopyToClipboardParams>
 */
export function appDashboardCopyToClipboard(params: appDashboardCopyToClipboardParams): LogObject<appDashboardCopyToClipboardParams> {
  return { evid: 3117, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'appHistoryRestoreVersionSuccess' event (evid: 3124)
 *
 * Event description: Fires when historic version was successfully restored
 *
 * @param {appHistoryRestoreVersionSuccessParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {string} version - version
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} buildType - build_type
 * @property {number} revisionNumber - revision_number
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<appHistoryRestoreVersionSuccessParams>} LogObject<appHistoryRestoreVersionSuccessParams>
 */
export function appHistoryRestoreVersionSuccess(params: appHistoryRestoreVersionSuccessParams): LogObject<appHistoryRestoreVersionSuccessParams> {
  return { evid: 3124, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'topBarTitleAction' event (evid: 3130)
 *
 * Event description: BI event indicating click or hover on top bar widget title
 *
 * @param {topBarTitleActionParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {string} componentType - component_type
 * @property {boolean} is_wix_app - is_wix_app
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {string} action - action
 * @return {LogObject<topBarTitleActionParams>} LogObject<topBarTitleActionParams>
 */
export function topBarTitleAction(params: topBarTitleActionParams): LogObject<topBarTitleActionParams> {
  return { evid: 3130, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'editorExperienceWelcomePanelClick' event (evid: 3135)
 *
 * Event description: The event fired when the user clicks on any button in the editor experience welcome panel
 *
 * @param {editorExperienceWelcomePanelClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} button_name - button_name
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @return {LogObject<editorExperienceWelcomePanelClickParams>} LogObject<editorExperienceWelcomePanelClickParams>
 */
export function editorExperienceWelcomePanelClick(params: editorExperienceWelcomePanelClickParams): LogObject<editorExperienceWelcomePanelClickParams> {
  return { evid: 3135, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'editorExperienceSwitchTabs' event (evid: 3136)
 *
 * Event description: The event fired when the user switch between tabs on the editor experience panel
 *
 * @param {editorExperienceSwitchTabsParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {string} targetTab - target_tab
 * @return {LogObject<editorExperienceSwitchTabsParams>} LogObject<editorExperienceSwitchTabsParams>
 */
export function editorExperienceSwitchTabs(params: editorExperienceSwitchTabsParams): LogObject<editorExperienceSwitchTabsParams> {
  return { evid: 3136, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsCreateNewAppClick' event (evid: 4202)
 *
 * Event description: The event is fired when the user clicks on create new app link in the private apps panel (fires also on "go to blocks" button in empty state)
 *
 * @param {privateAppsCreateNewAppClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {string} origin - origin
 * @property {GUID} appId - app_id
 * @return {LogObject<privateAppsCreateNewAppClickParams>} LogObject<privateAppsCreateNewAppClickParams>
 */
export function privateAppsCreateNewAppClick(params: privateAppsCreateNewAppClickParams): LogObject<privateAppsCreateNewAppClickParams> {
  return { evid: 4202, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsAvailableAppsContextMenuClick' event (evid: 4203)
 *
 * Event description: The event is fired when the user clicks on one of the options in the available apps context menu
 *
 * @param {privateAppsAvailableAppsContextMenuClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {string} origin - origin
 * @property {GUID} appId - app_id
 * @property {string} action - action
 * @return {LogObject<privateAppsAvailableAppsContextMenuClickParams>} LogObject<privateAppsAvailableAppsContextMenuClickParams>
 */
export function privateAppsAvailableAppsContextMenuClick(params: privateAppsAvailableAppsContextMenuClickParams): LogObject<privateAppsAvailableAppsContextMenuClickParams> {
  return { evid: 4203, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsInstalledAppsContextMenuClick' event (evid: 4204)
 *
 * Event description: The event is fired when the user clicks on one of the options in the available apps context menu
 *
 * @param {privateAppsInstalledAppsContextMenuClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {string} origin - origin
 * @property {GUID} appId - app_id
 * @property {string} action - action
 * @return {LogObject<privateAppsInstalledAppsContextMenuClickParams>} LogObject<privateAppsInstalledAppsContextMenuClickParams>
 */
export function privateAppsInstalledAppsContextMenuClick(params: privateAppsInstalledAppsContextMenuClickParams): LogObject<privateAppsInstalledAppsContextMenuClickParams> {
  return { evid: 4204, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsUpdateAppVersion' event (evid: 4205)
 *
 * Event description: The event is fired when the user clicks on update version in the context menu of an installed app
 *
 * @param {privateAppsUpdateAppVersionParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {string} version - version
 * @property {string} origin - origin
 * @property {GUID} appId - app_id
 * @return {LogObject<privateAppsUpdateAppVersionParams>} LogObject<privateAppsUpdateAppVersionParams>
 */
export function privateAppsUpdateAppVersion(params: privateAppsUpdateAppVersionParams): LogObject<privateAppsUpdateAppVersionParams> {
  return { evid: 4205, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsUninstallAppClick' event (evid: 4206)
 *
 * Event description: The event is fired when the user clicks on uninstall button in the uninstall modal
 *
 * @param {privateAppsUninstallAppClickParams} params - The parameters for this event
 * @property {GUID} appId - app_id
 * @property {string} builderType - builder_type
 * @return {LogObject<privateAppsUninstallAppClickParams>} LogObject<privateAppsUninstallAppClickParams>
 */
export function privateAppsUninstallAppClick(params: privateAppsUninstallAppClickParams): LogObject<privateAppsUninstallAppClickParams> {
  return { evid: 4206, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsUninstallAppSuccess' event (evid: 4207)
 *
 * Event description: The event is fired when the app was successfully uninstalled
 *
 * @param {privateAppsUninstallAppSuccessParams} params - The parameters for this event
 * @property {GUID} appId - app_id
 * @property {string} builderType - builder_type
 * @return {LogObject<privateAppsUninstallAppSuccessParams>} LogObject<privateAppsUninstallAppSuccessParams>
 */
export function privateAppsUninstallAppSuccess(params: privateAppsUninstallAppSuccessParams): LogObject<privateAppsUninstallAppSuccessParams> {
  return { evid: 4207, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsLeftTreeContextMenuClick' event (evid: 4208)
 *
 * Event description: The event is fired when clicking on specific item in the context menu of the private apps in the left tree
 *
 * @param {privateAppsLeftTreeContextMenuClickParams} params - The parameters for this event
 * @property {string} action - action
 * @property {string} builderType - builder_type
 * @return {LogObject<privateAppsLeftTreeContextMenuClickParams>} LogObject<privateAppsLeftTreeContextMenuClickParams>
 */
export function privateAppsLeftTreeContextMenuClick(params: privateAppsLeftTreeContextMenuClickParams): LogObject<privateAppsLeftTreeContextMenuClickParams> {
  return { evid: 4208, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsAutomaticMinorUpdatesToggle' event (evid: 4209)
 *
 * Event description: The event is fired when turning on and off the minor updates toggle
 *
 * @param {privateAppsAutomaticMinorUpdatesToggleParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {boolean} toggle - toggle
 * @property {boolean} isLastVersion - is_last_version
 * @property {GUID} appId - app_id
 * @return {LogObject<privateAppsAutomaticMinorUpdatesToggleParams>} LogObject<privateAppsAutomaticMinorUpdatesToggleParams>
 */
export function privateAppsAutomaticMinorUpdatesToggle(params: privateAppsAutomaticMinorUpdatesToggleParams): LogObject<privateAppsAutomaticMinorUpdatesToggleParams> {
  return { evid: 4209, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsAutomaticMinorUpdatesTurnedOn' event (evid: 4210)
 *
 * Event description: The event is fired when clicking on the "turn on" button in the automatic updates modal
 *
 * @param {privateAppsAutomaticMinorUpdatesTurnedOnParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {boolean} isLastVersion - is_last_version
 * @property {GUID} appId - app_id
 * @return {LogObject<privateAppsAutomaticMinorUpdatesTurnedOnParams>} LogObject<privateAppsAutomaticMinorUpdatesTurnedOnParams>
 */
export function privateAppsAutomaticMinorUpdatesTurnedOn(params: privateAppsAutomaticMinorUpdatesTurnedOnParams): LogObject<privateAppsAutomaticMinorUpdatesTurnedOnParams> {
  return { evid: 4210, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'privateAppsPrivateAppsLeftBarClick' event (evid: 4211)
 *
 * Event description: The event is fired when clicking on the Private Apps option inside the apps sub menu under the Editors Apps main menu
 *
 * @param {privateAppsPrivateAppsLeftBarClickParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @return {LogObject<privateAppsPrivateAppsLeftBarClickParams>} LogObject<privateAppsPrivateAppsLeftBarClickParams>
 */
export function privateAppsPrivateAppsLeftBarClick(params: privateAppsPrivateAppsLeftBarClickParams): LogObject<privateAppsPrivateAppsLeftBarClickParams> {
  return { evid: 4211, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'shareableUrlOpened' event (evid: 4212)
 *
 * Event description: BI event fired when the shareable URL is opened
 *
 * @param {shareableUrlOpenedParams} params - The parameters for this event
 * @property {string} url - url
 * @property {string} result - result
 * @property {string} component_category - component_category
 * @property {string} errorReason - error_reason
 * @property {string} componentType - component_type
 * @property {boolean} is_wix_app - is_wix_app
 * @property {GUID} appId - app_id
 * @property {string} component_id - component_id
 * @return {LogObject<shareableUrlOpenedParams>} LogObject<shareableUrlOpenedParams>
 */
export function shareableUrlOpened(params: shareableUrlOpenedParams): LogObject<shareableUrlOpenedParams> {
  return { evid: 4212, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'blocksAppCreatedServer' event (evid: 10104)
 *
 * Event description: Fires when an app id is created for the first time
 *
 * @param {blocksAppCreatedServerParams} params - The parameters for this event
 * @property {GUID} originAppId - origin_app_id
 * @property {string} templateName - template_name
 * @property {boolean} isDuplicate - is_duplicate
 * @property {GUID} templateId - template_id
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {GUID} originMsid - origin_msid
 * @property {GUID} msid - msid
 * @return {LogObject<blocksAppCreatedServerParams>} LogObject<blocksAppCreatedServerParams>
 */
export function blocksAppCreatedServer(params: blocksAppCreatedServerParams): LogObject<blocksAppCreatedServerParams> {
  return { evid: 10104, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'blocksReorderItemInList' event (evid: 10410)
 *
 * Event description: A users changed the index of an item in a list.
 *
 * @param {blocksReorderItemInListParams} params - The parameters for this event
 * @property {string} panelType - panel_type
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {boolean} notificationShow - notification_show
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} language - language
 * @property {string} origin - origin
 * @property {string} itemType - item_type
 * @property {string} itemId - item_id
 * @property {number} new_index - new_index
 * @property {string} itemName - item_name
 * @property {number} oldIndex - old_index
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @return {LogObject<blocksReorderItemInListParams>} LogObject<blocksReorderItemInListParams>
 */
export function blocksReorderItemInList(params: blocksReorderItemInListParams): LogObject<blocksReorderItemInListParams> {
  return { evid: 10410, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'modalShown' event (evid: 10412)
 *
 * Event description: When the modal is shown
 *
 * @param {modalShownParams} params - The parameters for this event
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {string} version - version
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} versionType - version_type
 * @property {string} language - language
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {string} modalName - modal_name
 * @return {LogObject<modalShownParams>} LogObject<modalShownParams>
 */
export function modalShown(params: modalShownParams): LogObject<modalShownParams> {
  return { evid: 10412, src: 110, endpoint: '', params };
}

/**
 * A function to create a log object for the 'updateAppSuccess' event (evid: 11002)
 *
 * Event description: The event is fired once the update of a Blocks app finishes successfully
 *
 * @param {updateAppSuccessParams} params - The parameters for this event
 * @property {GUID} appId - app id
 * @property {string} origin - {app item/ app details page/ automatic}
 * @property {string} builderType - {classic editor, editorX, studio}	
 * @property {string} appLatestVersion - What is the latest version of the app
 * @property {string} version - The version of the app that the user update to
 * @property {string} fullVersion - The full version of the app that the user update to
 * @return {LogObject<updateAppSuccessParams>} LogObject<updateAppSuccessParams>
 */
export function updateAppSuccess(params: updateAppSuccessParams): LogObject<updateAppSuccessParams> {
  return { evid: 11002, src: 110, endpoint: '', params };
}
